import { Spin, Typography, Card } from "antd";
import { SelectProperty } from "./SelectProperty/SelectProperty";
import { MembersTable } from "./Members/MembersTable";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useStore } from "../stores/root-store-context";
import { SelectGroup } from "./Groups/SelectGroup";
import { useDispatch } from "react-redux";
import Headers from "../../../../../redux/Actions/Headers/Header";

const { Title } = Typography;

export const Mat = observer(() => {
  const { applicationStore } = useStore();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      Headers.setHeader({
        title: "MAT - Member Adjustment Tool",
      })
    );
    return () => {
      dispatch(Headers.resetHeader());
    };
  }, [dispatch]);

  useEffect(() => {
    applicationStore.setIsLoading(true);
    applicationStore.loadPositions();
    applicationStore
      .loadPropertyList()
      .then(() => {
        applicationStore.setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        applicationStore.setIsLoading(false);
      });
  }, []);

  if (!applicationStore.isAuthorization) {
    return <Title level={3}>We&apos;re Sorry Your Request is Unauthorized</Title>
  }

  return (
    <Spin
      spinning={
        applicationStore.isLoadingProperty || applicationStore.isLoadGroups
      }
    >
      <div style={{ height: "100%", width: "100%", boxSizing: "border-box" }}>
        <Card
          style={{
            background: "#fff",
            borderRadius: 12,
            width: "100%",
            height: "100%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
          }}
          bodyStyle={{ padding: 0 }}
        >
          <div style={{ padding: 24 }}>
            <SelectProperty />
            <SelectGroup />
            <MembersTable />
          </div>
        </Card>
      </div>
    </Spin>
  );
});